<form class="simple-dialog" [formGroup]="form" appFormFields>
  <div class="simple-dialog__header">
    <h2 class="simple-dialog__title">{{title}}</h2>
  </div>
  <app-form-field name="input"></app-form-field>
  <div class="simple-dialog__actions">
    <button type="button" mat-button [mat-dialog-close]="{ cancel: true }" class="simple-dialog__button">
      {{cancelText}}
    </button>
    <button type="submit" mat-button [mat-dialog-close]="{ cancel: false, value: form.value.input}" class="simple-dialog__button simple-dialog__button_primary">
      {{okText}}
    </button>
  </div>
</form>
